


















































































import firebase from "firebase";
import { Component, Vue } from "vue-property-decorator";
@Component<Main>({})
export default class Main extends Vue {
  mounted(): void {
    firebase.analytics().setCurrentScreen("Main");
    firebase.analytics().logEvent("screen_view");
    document.body.style.overflowY = "scroll";
  }
}
